export const SERVER_ERROR = 'server_error';
export const CREATE_RIDE = 'create_ride';
export const UPDATE_RIDE = 'update_ride';
export const REMOVE_RIDES = 'remove_rides';
export const PURCHASE = 'purchase';
export const REFUND = 'refund';
